export const generateRandomId = () => Math.floor(Math.random() * Date.now());
